import React, { Component } from "react";
import Titulo from "../../generico/TituloPagina";
import DataTable from 'react-data-table-component';
import DatosSocio from "../../generico/DatosSocio"
import ComprobantesServices from "../../../services/consultas/comprobantesServices";
import { formatoSeparadorMilesValue } from '../../generico/utils/FormatoInput'
import { trackPromise } from "react-promise-tracker";
import authService from "../../../services/login/auth.service";
import Popup from "react-popup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload} from "@fortawesome/free-solid-svg-icons";
import $ from "jquery";


const paginationOptions = {
  rangeSeparatorText: "de",
  noRowsPerPage: true,

};

export default class PagoServicioComprobante extends Component {

  constructor(props) {
    super(props);
    this.state = {
      listaPago: [],
      periodoElegido: null,
      loading: false,
      totalRows: 0,
      perPage: 2
    };
  }
  componentDidMount() {
    this.obtenerListaPago();
    const { perPage } = this.state;

    //this.setState({ loading: true });

  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });
  getColumn() {
    return [
      {
        name: "Fecha",
        selector: row => row.fecha,
      },
      {
        name: "Cuenta",
        selector: row => row.cuenta,
      },
      {
        name: "Operacion",
        selector: row => row.operacion,
      },
      {
        name: "Servicio",
        selector: row => row.servicio,
        width: "350px"
      },
      {
        name: "Monto",
        selector: row => row.monto,
        right: true,
        width: "100px"
      },
      {
        cell: (row) => (
          <div>
            <button
              ref={() => this.entidadSelected}
              id={"imprimir_" + row.operacion}
              key={row.operacion}
              className="btn btn-xs btn-outline-success"
              value={row.operacion}
              onClick={this.selDescarga}
            ><FontAwesomeIcon icon={faDownload} /> <b>Descargar Ticket</b></button>
          </div>
        )
      }]
  }
  selDescarga = (e) => {
    var operacion = e.currentTarget.value;
    var foundItem = $.grep(this.state.listaPago, function (v) {
      var item = v.operacion;
      return item.trim() === operacion.toString();
    });
    this.descargar(foundItem[0]);
  };

  descargar(row){
    trackPromise(
      ComprobantesServices.descagarComprobante("Pagos de Servicios", row.operacion, authService.getSocio().numeroSocio.trim() +" - "+authService.getSocio().nombreCompleto, row.cuenta, row.ticket)
        .then((response) => {
          var fileURL = URL.createObjectURL(response.data);
          window.open(fileURL, "");         
        })
        .catch(function (error) {
          console.log(error);
        })
    );

  };

  obtenerListaPago = () => {
    var listaPago = [];

    trackPromise(
      ComprobantesServices.comprobantesPronet("1", "WEB")
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
         // console.log(jsonData)
          if (jsonData.paginas !== "0") {
            for (var i = 0; i < jsonData.map.length; i++) {
              listaPago.push({
                fecha: jsonData.map[i].FECHA,
                cuenta: jsonData.map[i].CUENTA,
                operacion: jsonData.map[i].OPERACION,
                servicio: jsonData.map[i].SERVICIO,
                monto: formatoSeparadorMilesValue(jsonData.map[i].MONTO),
                ticket: jsonData.map[i].TICKET
                
              });
            }
            
            this.setState({ listaPago: listaPago, totalRows: jsonData.paginas });
            this.setState({ listaPago: listaPago });
          }

          else {
            Popup.queue(this.notifiPopup("Info", "No tiene comprobantes"));
            this.setState({ listaPago: [] });
            return;
          }
        }).catch(function (error) {
          //authService.logout()
          console.log(error)
        }));
  }

  handlePageChange = (page) => {
    const { perPage } = this.state;

    this.setState({ loading: true });
    var listaPago = [];

    trackPromise(
      ComprobantesServices.comprobantesPronet(page, "WEB")
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          if (jsonData.paginas !== "0") {
            for (var i = 0; i < jsonData.map.length; i++) {
              listaPago.push({
                fecha: jsonData.map[i].FECHA,
                cuenta: jsonData.map[i].CUENTA,
                operacion: jsonData.map[i].OPERACION,
                servicio: jsonData.map[i].SERVICIO,
                monto: formatoSeparadorMilesValue(jsonData.map[i].MONTO),
                ticket: jsonData.map[i].TICKET
                
              });
            }
            //  this.setState({ listaPago: listaPago, totalRows: jsonData.paginas });
            this.setState({ listaPago: listaPago });
          }

          else {
            Popup.queue(this.notifiPopup("Info", "No tiene comprobantes"));
            this.setState({ listaPago: [] });
            return;
          }
        }).catch(function (error) {
         // authService.logout()
          console.log(error)
        }));

  }

  handlePerRowsChange = (perPage, page) => {
    this.setState({ loading: true });
    var listaPago = [];

    trackPromise(
      ComprobantesServices.comprobantesPronet(page, "WEB")
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          if (jsonData.paginas !== "0") {
            for (var i = 0; i < jsonData.map.length; i++) {
              listaPago.push({
                fecha: jsonData.map[i].FECHA,
                cuenta: jsonData.map[i].CUENTA,
                operacion: jsonData.map[i].OPERACION,
                servicio: jsonData.map[i].SERVICIO,
                monto: formatoSeparadorMilesValue(jsonData.map[i].MONTO),
                ticket: jsonData.map[i].TICKET
              });
            }
            //  this.setState({ listaPago: listaPago, totalRows: jsonData.paginas });
            this.setState({ listaPago: listaPago });
          }

          else {
            Popup.queue(this.notifiPopup("Info", "No tiene comprobantes"));
            this.setState({ listaPago: [] });
            return;
          }
        }).catch(function (error) {
          authService.logout()
          //console.log(error)
        }));

  }

  render() {
    return (
      <div className="content-wrapper">
        <Titulo texto="Pago de Servicios - Comprobantes" />
        <section className="content">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <DatosSocio />
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="table-responsive">
                          <DataTable
                            pagination={true}
                            columns={this.getColumn()}
                            data={this.state.listaPago}
                            paginationComponentOptions={paginationOptions}
                            noDataComponent="no hay registros para mostrar"
                            paginationServer
                            paginationTotalRows={this.state.totalRows}
                            // onChangeRowsPerPage={this.handlePerRowsChange}
                            onChangePage={this.handlePageChange} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );

  }
}
//storiesOf('Pagination', module).add('Server-Side', () => <PagoServicioComprobante />);
